<div>
    <mat-card>
      <mat-card-title class="title-center">Months List</mat-card-title>
    
      <div class="outer-scroll-wrapper">
        <div class="inner-scroll-container mat-elevation-z8">
          <table mat-table [dataSource]="months" class="full-width-table">
    
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let month">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon><b>⋮</b></mat-icon>
                </button>
            
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="change_status(month.id)">
                        <mat-icon>{{ month.is_active ? 'cancel' : 'check_circle' }}</mat-icon>
                        <span>{{ month.is_active ? 'Deactivate' : 'Activate' }}</span>
                    </button>
                </mat-menu>
              </td>
            </ng-container>
            
            
            
    
            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef> S.No. </th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{ currentPage + i + 1 }}
              </td>
            </ng-container>
    
            <!-- Define columns -->
            <ng-container matColumnDef="months_name">
              <th mat-header-cell *matHeaderCellDef> Months Name </th>
              <td mat-cell *matCellDef="let s"> {{ s.months_name }} </td>
            </ng-container>
  
            <ng-container matColumnDef="is_active">
              <th mat-header-cell *matHeaderCellDef> Active status </th>
              <td mat-cell *matCellDef="let s">
                <mat-icon color="{{ s.is_active ? 'primary' : 'warn' }}">
                  {{ s.is_active ? 'check_circle' : 'cancel' }}
                </mat-icon>
              </td>
            </ng-container>
    
            <!-- Header and Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
    </mat-card>
</div>